module.exports = __webpack_public_path__ + "static/media/ka-wb.dbaa8d34.png";